<script type="text/ecmascript-6">

import { h } from 'vue'

export default {
  name: 'VRow',
  props: {
    element: {
      type: String,
      default: 'div'
    }
  },
  render () {
    const data = { class: 'row' }
    return h(this.element, data, this.$slots?.default?.())
  }
}

</script>
